import { Visibility } from "@mui/icons-material";
import CommonAutocomplete from "../../../../../components/CommonAutocomplete";
import IntersectionObservedView from "../../../../../components/IntersectionObservedView";

function OriginSelect({value, origins, onSelect, ...prop}) {

  return (
    <IntersectionObservedView
      rootMargin = "50px"
    >
      <CommonAutocomplete
        value={value || null}
        onSelect={(_e, value) => {
          onSelect(value)
        }}
        data={origins}
        filterOptions={(options, { inputValue }) => {
          return options.filter((option) => {
            return option.originId?.toString().includes(inputValue);
          });
        }}
        optionLabel={(option) =>
          option ? option.originId + " - " + option.originName : ""
        }
        {...prop}
      />
    </IntersectionObservedView>
  );
}

export default OriginSelect;
